export const FORMIO_WIZARD = 'wizard';
export const FORMIO_FORM = 'form';
